<template>
    <div class="container_view">
        <v-card class="content_card_adapt" elevation="10" variant="flat" style="width: 700px !important;">
            <v-sheet>
                <v-card-item>
                    <template v-slot:prepend>
                        <v-card-title> Gestiones </v-card-title>
                    </template>
                    <v-divider vertical class="mx-2"></v-divider>            
                </v-card-item>
            </v-sheet>
            <v-divider class="mx-3"></v-divider>
            <div class="px-6 py-12">
                <v-form class="override_content_flex" @submit.prevent="search()">
                    <div class="col-flex-12">
                        <v-select
                            label="Tipo de Búsqueda" 
                            v-model="formGroup.data.tipo"
                            :rules="formGroup.rules.tipo"
                            variant="outlined"
                            class="w-100 mb-2"
                            :items="arrDataTypes"
                            item-title="value"
                            item-value="key">
                        </v-select>
                    </div>
                    <div class="col-flex-12">
                        <v-text-field  
                            label="Dato a Buscar" 
                            v-model="formGroup.data.dato"
                            :rules="formGroup.rules.dato"
                            variant="outlined"
                            class="w-100 mb-2">
                        </v-text-field>
                    </div>
                    <div class="col-flex-12">
                        <v-btn 
                            block 
                            color="indigo-darken-3" 
                            size="large"
                            type="submit"
                            :loading="isLoading"
                            :disabled="validateForm()"
                            prepend-icon="mdi-magnify">
                            Buscar
                        </v-btn>
                    </div>
                </v-form>
            </div>
        </v-card>
        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>

<script>
    import SnackbarComponent from '@/components/Snackbar'
    import { EncryptService } from '@/services/EncryptService'
    export default {
        name: 'ManagementView',
        props: {
            msg: String
        },
        components: {
            SnackbarComponent,
        },
        data() {
            return {
                isLoading: false,
                arrDataTypes: [
                    {
                        key: 1,
                        value: 'Cliente Único'
                    },
                    {
                        key: 2,
                        value: 'Nombre del Títular o Aval'
                    },
                    {
                        key: 3,
                        value: 'Teléfono'
                    },
                    {
                        key: 4,
                        value: 'Teléfono del Aval'
                    },
                    {
                        key: 5,
                        value: 'Número del Grupo'
                    },
                    {
                        key: 6,
                        value: 'Nombre del Grupo'
                    },
                ],
                formGroup: {
                    data: {
                        tipo: 2,
                        dato: null,
                    },
                    rules: {
                        tipo: [
                            value => {
                                if (value === null || value === undefined || value === '') {
                                    return `El campo Tipo de Búsqueda es obligatorio`
                                }
                                return true
                            }
                        ],
                        dato: [
                            value => {
                                if (value === null || value === undefined || value === '') {
                                    return `El campo Dato a Buscar es obligatorio`
                                }
                                return true
                            }
                        ],
                    }
                },
                snackbarData: {
                    openSnackbar: false,
                    description: '',
                },
            }
        },
        methods: {
            search: async function () {
                if (this.validateForm() || this.isLoading) {
                    return;
                }
                this.isLoading = true
                try {
                    const strData = JSON.stringify(this.formGroup.data)
                    const encData = await EncryptService.encrypt(strData)
                    await this.$router.push({
                        name: 'management-search-results',
                        params: { form: encData },
                    })
                } catch (error) {
                    this.snackbarData.description = 'No se pudo abrir la búsqueda. Intente de nuevo.'
                    this.snackbarData.openSnackbar = true
                } finally {
                    this.isLoading = false
                }
            },
            validateForm: function () {
                let tipo = this.formGroup.data.tipo
                if (tipo === null || tipo === undefined || tipo === '') {
                    return true
                }
                let dato = this.formGroup.data.dato
                if (dato === null || dato === undefined || dato === '') {
                    return true
                }
                return false
            },

        }
    }
</script>

<style scoped>

    .card {
        width: 90%;
        height: calc(100vh - 160px);
        overflow: auto;
    }

    .content_form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100vh;
        width: 100%;
    }
</style>